import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ContentBottom from '../../components/ContentBottom';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import useForm from '../../helpers/useForm';
import { WelletContext } from '../../context/WelletContext';
import { format } from 'date-fns';
import { getQueryString } from '../../helpers/url';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';

import ButtonProccessing, {
  ButtonStatus,
} from '../../components/Common/ButtonProccessing/ButtonProccessing';
import BankIcon from '../../components/icons/BankIcon';
import styles from './ConfirmAddAccount.module.css';
import ProductModal from '../../components/Common/ProductModal/ProductModal';
import { getLocale } from '../../helpers/dates';
const ConfirmAddAccount = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const welletContext = useContext(WelletContext);
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [userInfo, setUserInfo] = useState(null);
  const [accountInfo, setAccountInfo] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const language = useSelector((state) => state.app.language);
  const id = getQueryString('id');

  const fetchUser = async () => {
    try {
      const response = await welletContext.apis.tickets.get(`/users/getprofile`);
      if (response.status === 200) {
        setUserInfo(response.data);
        //setLoading(false);
      }
    } catch (error) {
      console.error(error);
      //setLoading(false);
    }
  };

  const fetchAccount = async () => {
    try {
      const response = await welletContext.apis.tickets.get(`/withdrawal/accounts/${id}`);

      if (response.status === 200) {
        setAccountInfo(response.data);
        dispatch({
          type: 'USER_WITHDRAWAL',
          payload: response.data.withdrawal,
        });
        //setLoading(false);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.errorDescription);
      console.error(error);
      //setLoading(false);
    }
  };

  const updateAccount = async () => {
    try {
      setBtnStatus(ButtonStatus.InProgress);
      const response = await welletContext.apis.tickets.post(`/withdrawal/accounts/${id}`, {
        acceptTos: true,
      });
      dispatch({
        type: 'USER_WITHDRAWAL',
        payload: response.data.withdrawal,
      });

      if(response.data.withdrawal.status !== 'APPROVED') {
        setBtnStatus(ButtonStatus.ProgressFinished);
        setTimeout(() => {
          history.push(`/`);
        }, 1000);
      }
      else {
        setBtnStatus(ButtonStatus.ProgressFinished);
        setTimeout(() => {
          history.push(`/success-add-account`);
        }, 1000);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.errorDescription);
      setBtnStatus(ButtonStatus.Normal);
      console.error(error);
    }
  };

  function validate(values) {
    let errors = {};

    return errors;
  }

  const sendForm = async () => {};

  let { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  useEffect(() => {
    if (userInfo == null) {
      fetchUser();
    }

    if (accountInfo == null) {
      fetchAccount();
    }
  }, []);

  const bankAccount = accountInfo?.externalAccounts ? accountInfo.externalAccounts[0] : null;
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
    window.scrollTo(0, 0);
  };
  const taxNames = { ES: 'NIF', MX: 'RFC', US: 'SSN', DO: 'RNC' };
  const openModal = () => setModalOpen(true);
  return (
    <>
      <Header />
      <ContentApp>
        {userInfo != null && accountInfo != null && (
          <>
            <div className='fw-bold font-medium mt-4'>{t('confirmAddAccount.reviewAndSend')}</div>
            <div className='text-secondary mt-1'>
              {t('confirmAddAccount.pleaseMinutesReviewYourInformation')}
            </div>

            <div className='font-tiny text-primary fw-semibold mt-4'>
              {t('confirmAddAccount.professionalData')}
            </div>
            <div className={`${styles.containerBorder} mt-2 p-3`}>
              <div className='text-secondary font-tiny'>{t('confirmAddAccount.sectorHeading')}</div>
              <div className='fw-semibold mt-1'>{userInfo.activityName}</div>
              <div className='text-secondary font-tiny mt-3'>
                {t('confirmAddAccount.otherDataProvided')}
              </div>
              <div className='fw-semibold mt-1'>{userInfo.jobTitle}</div>
            </div>

            <div className='font-tiny text-primary fw-semibold mt-4'>
              {t('confirmAddAccount.personalData')}
            </div>
            <div className={`${styles.containerBorder} mt-2 p-3`}>
              <div className='fw-bold'>
                {accountInfo.firstName} {accountInfo.lastName}
              </div>
              <div className='text-secondary font-tiny mt-3'>{t('confirmAddAccount.email')}</div>
              <div className='fw-semibold mt-1'>{accountInfo.email}</div>
              <div className='text-secondary font-tiny mt-3'>
                {t('confirmAddAccount.birthDate')}
              </div>
              <div className='fw-semibold mt-1'>
                {' '}
                {format(new Date(accountInfo.birthDate.replace(/([+-]\d{2}:\d{2})$/, '')), 'PPP', {
                  locale: getLocale(language),
                })}
              </div>
              <div className='text-secondary font-tiny mt-3'>{t('confirmAddAccount.address')}</div>
              <div className='fw-semibold mt-1'>
                {accountInfo.address.line1 +
                  ' - ' +
                  accountInfo.address.city +
                  ' - ' +
                  accountInfo.address.state +
                  ' - ' +
                  accountInfo.address.country}
              </div>
            </div>

            <div className='font-tiny text-primary fw-semibold mt-4'>
              {t('confirmAddAccount.transferData')}
            </div>
            <div className={`${styles.containerBorder} mt-2 p-3`}>
              <div className='row'>
                {bankAccount ? (
                  <>
                    <div className='col-auto my-auto pr-0'>
                      <BankIcon color='#fff' size='28' />
                    </div>
                    <div className='col pr-0'>
                      <div className='fw-semibold'>{bankAccount.bankName}</div>
                      <div className='mt-1 font-small'>
                        {bankAccount.routingNumber} •••• {bankAccount.last4}
                      </div>
                    </div>
                    <div className='col-auto fw-bold font-normal my-auto text-uppercase'>
                      {bankAccount.currency}
                    </div>
                  </>
                ) : null}
              </div>
            </div>
            <div className='text-secondary font-small mt-4'>
              {t('welletUsesStripeToMakePayments.clarification1')}
              <span className='text-tertiary fw-bold' onClick={openModal}>
                {t('welletUsesStripeToMakePayments.part2')}
              </span>
              {t('welletUsesStripeToMakePayments.clarification2')}
            </div>

            <ProductModal
              fullScreen={true}
              hasBackground
              backIcon={true}
              open={isModalOpen}
              onClose={toggleModal}
              animationClass='slide-left-right'
            >
              <div className='text-secondary font-small  pl-4 pr-4'>
                {t('welletUsesStripeToMakePayments.part1')}
                <a
                  href='https://stripe.com/es-us/legal/connect-account/recipient'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <u className='text-primary'>{t('welletUsesStripeToMakePayments.part2')}</u>
                </a>
                {t('welletUsesStripeToMakePayments.part3')}
              </div>
            </ProductModal>
          </>
        )}
      </ContentApp>
      <ContentBottom>
        {errorMessage && (
          <div className='mt-2'>
            <ErrorBox title={'Error'} description={errorMessage} />
          </div>
        )}
        <ButtonProccessing
          status={btnStatus}
          text={'Aceptar y enviar'}
          size='large'
          className={`mt-5`}
          type='submit'
          onClick={() => updateAccount()}
          arrow
          color='#000'
          backgroundColor='var(--color-primary)'
          iconColor='#000'
        />
      </ContentBottom>
    </>
  );
};

export default ConfirmAddAccount;
